import { getSubdomain, fetchWithAuth } from '../helpers';
import { API_PASSWORD } from '../config';


export const getPrintersByBranch = async () => {
  const subdomain = getSubdomain();
  const rootId = localStorage.getItem("branch_id"); // ✅ Retrieve rootId from local storage
  const url = `https://${subdomain}.restocash.app/api/get/printers/${rootId}?api_password=${API_PASSWORD}`;

  const response = await fetchWithAuth(url, {
    method: "GET",
  });

  const text = await response.text();

  let data;
  try {
    data = JSON.parse(text);
  } catch (err) {
    console.error("🚫 الرد غير صالح (HTML بدلاً من JSON):", text);
    throw new Error("⚠️ لم يتم العثور على المسار أو الرد ليس بصيغة JSON.");
  }

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في جلب الطابعات");
  }

  return data.data?.data || [];
};


export const savePrinter = async (printerData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/save/printer`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);
  formData.append("root_id", printerData.root_id);
  formData.append("name", printerData.name);
  formData.append("cashier_printer", printerData.cashier_printer);
  formData.append("local_url", printerData.local_url || ""); // Include additional info field

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true); // FormData mode

  const data = await response.json();

  if (!response.ok) {
    console.error("❌ API Error:", data);
    throw new Error(data.message || "❌ فشل في حفظ الطابعة.");
  }

  return data;
};





// الطباعه
export const printItems = async (items) => {
  const apiPassword = "Project102$_";
  const subdomain = getSubdomain(); // أو اكتبه مباشرة "test01" لو ثابت

  const apiUrl = `https://${subdomain}.restocash.app/api/print-items?api_password=${apiPassword}`;

  try {
    console.log("📡 إرسال طلب لطباعة العناصر عبر:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في طباعة العناصر:", data);
      throw new Error(data?.message || "فشل في طباعة العناصر.");
    }

    console.log("✅ تم طباعة العناصر بنجاح:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء الاتصال بالسيرفر:", error);
    throw error;
  }
};

// تحديث بيانات الطابعة
export const updatePrinter = async (printerId, printerData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/printer/${printerId}?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  formData.append("cashier_printer", printerData.cashier_printer);
  formData.append("name", printerData.name);
  formData.append("local_url", printerData.local_url);
  formData.append("root_id", printerData.root_id);

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true); // FormData mode

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تحديث بيانات الطابعة.");
  }

  return data;
};

// تغيير حالة الطابعة (تفعيل/تعطيل)
export const changePrinterStatus = async (printerId) => {
  const subdomain = getSubdomain();
  const apiPassword = "Project102$_";
  const token = localStorage.getItem("token");

  const apiUrl = `https://${subdomain}.restocash.app/api/change/printer/status/${printerId}?api_password=${apiPassword}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "❌ فشل في تغيير حالة الطابعة.");
  }

  return data;
};

// ضع عناصر كقيد تجهيز عبر API (items: مصفوفة من معرفات الأصناف)
export const makeItemsInPreparation = async (items = []) => {
  const apiPassword = API_PASSWORD || "Project102$_";
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/make/item/in/prepration?api_password=${apiPassword}`;

  try {
    console.log("📡 إرسال طلب وضع العناصر قيد التحضير إلى:", apiUrl, "items:", items);

    const response = await fetchWithAuth(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في وضع العناصر قيد التحضير:", data);
      throw new Error(data?.message || "❌ فشل في وضع العناصر قيد التحضير.");
    }

    console.log("✅ استجابة وضع العناصر قيد التحضير:", data);
    return data;
  } catch (error) {
    console.error("🔥 خطأ أثناء طلب وضع العناصر قيد التحضير:", error);
    throw error;
  }
};

// جلب عدد مرات الطباعة للأوردَر
export const getCountPrintOrder = async (orderId) => {
  const subdomain = getSubdomain();
  const token = localStorage.getItem("token");
  const apiUrl = `https://${subdomain}.restocash.app/api/count/print/order/${orderId}?api_password=${API_PASSWORD}`;

  try {
    console.log("📡 إرسال طلب جلب عدد طباعات الأوردر من:", apiUrl);

    const response = await fetchWithAuth(apiUrl, {
      method: "GET",
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("❌ فشل في جلب عدد الطباعات:", data);
      throw new Error(data?.message || "❌ فشل في جلب عدد طباعات الأوردر.");
    }

    console.log("✅ عدد طباعات الأوردر:", data);
    return data.data ?? data;
  } catch (error) {
    console.error("🔥 خطأ أثناء جلب عدد الطباعات:", error);
    throw error;
  }
};



